import { render } from "./Community.vue?vue&type=template&id=7ded7eb2&scoped=true"
import script from "./Community.vue?vue&type=script&lang=js"
export * from "./Community.vue?vue&type=script&lang=js"

import "./Community.vue?vue&type=style&index=0&id=7ded7eb2&scoped=true&lang=css"

import exportComponent from "/var/www/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7ded7eb2"]])

export default __exports__